"use client";

import React, { ReactNode, useEffect, useState } from 'react';
import { Overlay } from 'react-vant';
import styles from '@/styles/global/dialog.module.scss';
import { Button } from "react-vant";
import { Cross } from '@react-vant/icons';

interface DialogProps {
  visible: boolean;
  title?: string;
  children?: ReactNode;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onCancel?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
  className?: string;
  confirmLoading?: boolean;
  closeable?: boolean;
  contentStyle?: React.CSSProperties;
  dialogContentStyle?: React.CSSProperties;
}

const Dialog: React.FC<DialogProps> = ({
  visible,
  title,
  children,
  showConfirmButton = true,
  showCancelButton = true,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  onCancel,
  onClose,
  onConfirm,
  className,
  confirmLoading,
  closeable = false,
  contentStyle,
  dialogContentStyle
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return (
    <Overlay
      visible={visible}
      onClick={onClose || onCancel}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      className={className}
      zIndex={9}
    >
      <div 
        className={styles['dialog-content']}
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'relative', ...dialogContentStyle }}
      >
        {closeable && (
          <div 
            className={styles['dialog-close']}
            onClick={onClose || onCancel}
          >
            <Cross fontSize={22} color='#666666' />
          </div>
        )}

        {
          title ? (
            <div className={styles['dialog-title']}>{title}</div>
          ) : null
        }

        <div style={{ padding: '10px 20px 20px', ...contentStyle }}>
          {children}
        </div>
        {(showConfirmButton || showCancelButton) && (
          <div 
            style={{ 
              padding: '16px 20px',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            {showCancelButton && (
              <Button
                round
                block
                style={{ 
                  flex: 1,
                  height: '38px',
                  marginRight: showConfirmButton ? '8px' : 0,
                  fontSize: '16px',
                  fontWeight: '700'
                }}
                onClick={onCancel}
              >
                {cancelButtonText}
              </Button>
            )}
            {showConfirmButton && (
              <Button
                round
                type="primary"
                block
                style={{ 
                  flex: 1,
                  height: '38px',
                  marginLeft: showCancelButton ? '8px' : 0,
                  fontSize: '16px',
                  fontWeight: '700'
                }}
                loading={confirmLoading}
                loadingText={confirmButtonText}
                onClick={onConfirm}
              >
                {confirmButtonText}
              </Button>
            )}
          </div>
        )}
      </div>
    </Overlay>
  );
};

export default Dialog;
